<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-badge class="bg-blue">
            <i class="fa fa-file mr-2"></i>
            Appointment of Secretary
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <Form20SecretaryResolution :data="getCompanySecretary ? getCompanySecretary.data : null" badge="Current Secretary"></Form20SecretaryResolution>
        </b-col>
        <b-col>
          <Form20SecretaryResolution :data="data" badge="New Secretary"></Form20SecretaryResolution>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import Form20SecretaryResolution from "@/views/home/services/continuous-filing/task/forms/Form20SecretaryResolution";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ChangeOfSecretary",
  components: { Form20SecretaryResolution },
  props:{
    data:Object,
    brn:String
  },
  mounted() {
    this.fetchCompanySecretary(this.brn)
  },
  methods:{
    ...mapActions(["fetchCompanySecretary"]),
  },
  computed:{
    ...mapGetters(["getCompanySecretary"])
  }
};
</script>

<style scoped>
th, td{
  font-size: 12px;
}

.pdf{
  width: 100%;
  height: 800px;
  overflow-x: auto;
  border:1px solid #b1b1b1;
}
</style>